import type { ViewComponent } from "@frui.ts/views";
import type SubLedgerNewReportViewModel from "../../../../viewModels/finance/subLedger/SubLedgerNewReportViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import React from "react";
import { Input } from "@frui.ts/bootstrap";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";

export const SummaryParameters: ViewComponent<SubLedgerNewReportViewModel> = observer(({ vm }) => {
  return (
    <div style={{ paddingBottom: "2.5rem" }}>
      <h5>{vm.translate("summaryParameters.name")}</h5>

      <div className="row">
        <Form.Group as={Col} md={6} lg={4} xl={2}>
          <Form.Label>{vm.translate("summaryParameters.sequenceName")}</Form.Label>
          <AdvancedInput
            transformation={Transformation.UpperCased}
            target={vm.summary}
            placeholder={vm.translate("summaryParameters.sequenceName")}
            property="sequenceName"
            disabled={!vm.canEditSummary}
          />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("summaryParameters.sequenceNumber")}*</Form.Label>
          <Input
            target={vm.summary}
            property="sequenceNumber"
            placeholder={vm.translate("summaryParameters.sequenceNumber")}
            disabled={!vm.canEditSummary}
            type="number"
          />
        </Form.Group>

        <Form.Group as={Col} md={6} lg={4} xl={2}>
          <Form.Label>{vm.translate("summaryParameters.accountingPeriod")}</Form.Label>
          <AdvancedSelect
            target={vm.summary}
            property="accountingPeriod"
            placeholder={vm.translate("summaryParameters.accountingPeriod")}
            allowEmpty={true}
            items={vm.accountingPeriodOptions}
            disabled={!vm.canEditSummary}
          />
        </Form.Group>
      </div>
    </div>
  );
});
